import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Constants from "../../../util/Constants";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import ApiUiController from "../../../controller/ApiUiController";
import { CSVLink } from "react-csv";
import { Button, Table } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import StackedChartComponent from "../chartComponent/MultiBarChart";
import FilterPannel from "../../filter/FilterPannel";
import moment from "moment";



class MonthlyLeadsBySalesExecutiveReport extends React.Component {
  constructor(props) {
    super(props);
    const model = reactLocalStorage.getObject(Constants.Model)
    const monthOptions = Constants.Months || [];
    const userOptions  = model.user.options.filter((options)=>options.status === Constants.Active || options.status === Constants.AlwaysActive) || [];
    this.fields = model.lead.fields;
    this.loggedInUserId = reactLocalStorage.getObject(Constants.LoggedInUser).user_id;
    this.state = {
      progressData: [],
      monthOptions,
      userOptions,
      filters: [{
        field: "responsible_person",
        condition: "in",        
        value: `~${this.loggedInUserId}~`,
      },{
        "field": "enquiry_date",
        "condition": "in",
        "value": `${moment.utc().startOf('year').format('YYYY-MM-DDTHH:mm:ss.SSSZ')} ~ ${moment.utc().endOf('year').format('YYYY-MM-DDTHH:mm:ss.SSSZ')}`
      }],
      tableData:[],
      series: [],
      inApiCall: false,
      isFilterOpen: true,
      exportData: [],
    };
  }

  componentDidMount(l) {
    this.fetchApi(this.state.filters,this.onSuccess, this.onFail);
  }


 fetchApi = (filters,onSuccess, onFail) => {
    const body = {
      filters : filters,
      model: "lead_model",
      x:"enquiry_date",
      y:"responsible_person",
      z:"COUNT(id)"
    }
    this.setState({inApiCall: true})
    DailySalesReportAPI.getFixedReport(body, onSuccess, onFail);
  };

  parseData=(response )=>{
    let selectedUserId ,filteredUserOptions;
    this.state.filters.map(filter => filter.field === 'responsible_person' ?  selectedUserId = filter.value.split(Constants.Opt).filter(Boolean) : null);
    filteredUserOptions = this.state.userOptions.filter(user => { 
      if (Boolean(selectedUserId)) {
        return selectedUserId?.some(id => parseInt(id) === user.value);
      }
      return true;
    });
    // multi Prepare table data
    const tableData = this.state.monthOptions.map((month) => {
      const row = { month: month.label };
      filteredUserOptions.forEach((user) => {
        // Calculate the total sum for each responsible project per user
        const totalSum = response
          .filter(
            (item) =>
              {
                const monthNo = new Date(item.enquiry_date).getMonth() + 1; 
                return monthNo === parseInt(month.value) &&
              item.responsible_person.includes(`~${user.value}~`)  
          })
          .reduce((sum, item) => sum + (item.sum || 0), 0);
  
        row[user.name] = totalSum;
      });
      return row;
    });
  
    // Prepare chart series
    const series = filteredUserOptions.map((user) => ({
      name: user.name,
      data: this.state.monthOptions.map((month) => {
        // Calculate the total sum for each responsible project per user
        const totalSum = response
          .filter(
            (item) =>
              {
                const monthNo = new Date(item.enquiry_date).getMonth() + 1; 
                return monthNo === parseInt(month.value) &&
                item.responsible_person.includes(`~${user.value}~`) 
          })
          .reduce((sum, item) => sum + (item.sum || 0), 0);
  
        return totalSum;
      }),
    }));
  return { tableData, series };

}

  onSuccess =(data)=>{
    const {tableData , series} = this.parseData(data);
    const exportData = tableData;
    this.setState({ tableData,series ,exportData, inApiCall: false  });  
  }

  onFail = (err) =>{
    console.log("Failed to fetch data" , err);
  }

  toggleFilter = () => {
    this.setState((prevState) => ({
      isFilterOpen: !prevState.isFilterOpen,
    }));
  };

  onFilterChange = (updatedFilters) => {
    this.setState({ filters: updatedFilters },    
     this.fetchApi(this.state.filters,this.onSuccess, this.onFail));
  };


  render(){
  const {exportData , filters ,isFilterOpen , inApiCall , userOptions ,monthOptions, tableData , series  } = this.state;
    let selectedUserId ,filteredUserOptions;
    filters.map(filter => filter.field === 'responsible_person' ?  selectedUserId = filter.value.split(Constants.Opt).filter(Boolean) : null);
    filteredUserOptions = userOptions.filter(user => { 
      if (Boolean(selectedUserId)) {
        return selectedUserId?.some(id => parseInt(id) === user.value);
      }
      return true;
    })

    const table = (<Table bordered hover>
      <thead>
        <tr>
          <th></th>
          {filteredUserOptions.map((person, index) => (
            <th key={index}>{person.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableData.map((row, index) => (
          <tr key={index}>
            <td>{row.month}</td>
            {filteredUserOptions.map((person, idx) => (
              <td key={idx}>{row[person.label]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>);

  return (
        <ApiUiController inApiCall={inApiCall}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">
                  <h1>Monthly Leads By Sales Executive Report</h1>
                </div>
                <div className="col-md-6">
                  <CSVLink
                  data={exportData} filename={`monthly_leads_By_sales_executive_report.csv`}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.state.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            <div className="container-fluid">
              <div className="row">
                <div className={`col-md-${isFilterOpen ? 9 : 12}`}>
                <StackedChartComponent progressOptions={monthOptions} progressSums={series} type={"multiBar"} />
                <div className="col-md-12">{table}</div>
                </div>
                {this.state.isFilterOpen && (
                  <FilterPannel
                    filters={filters}
                    fields={this.fields}
                    onFilterChange={this.onFilterChange}
                    isFilterOpen={isFilterOpen}
                    restrict={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>)


  }
}


export default MonthlyLeadsBySalesExecutiveReport;



